import {IdSelect} from "./id-select";
import {useExportMarkets} from "./api";
import React from "react";
import {SelectProps} from "antd";

export const ExportMarketSelect = (props: SelectProps) => {
  const {data: exportMarkets} = useExportMarkets();
  return <IdSelect data={exportMarkets || []} {...props} />;
};
